import styled from '@emotion/styled';
import { TextStyle } from '../../../styles/variables/mixins';
import { Colors } from '../../../styles/variables/colors';
import { Breakpoints } from '../../../styles/variables/breakpoints';
import { NavLink as NavLinkComponent } from 'react-router-dom';
import { ListItemButton } from '@mui/material';

const { formBackground, darkGray, blue, white, purple, darkBlack } = Colors;
const { lg, xl } = Breakpoints;

export const Box = styled.div`
    width: 100%;
    padding: 38px;
    padding-top: 28px;
    padding-bottom: 22px;
    background-color: ${formBackground};
    margin-bottom: 25px;
    /* is this in all */
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 1.25rem;
    @media screen and (min-width: ${xl}) {
        min-width: 430px;
        width: 100%;
    }
`;

export const BoxPart1 = styled.div`
    width: 100%;
    padding: 38px;
    padding-top: 28px;
    padding-bottom: 22px;
    background-color: ${formBackground};
    margin-bottom: 25px;
    @media screen and (min-width: ${xl}) {
        min-width: 430px;
        width: 100%;
    }
`;

export const BoxPart2 = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 1.25rem;
`;

export const Container = styled.div`
    display: flex;
    gap: 64px;
    margin-top: 34px;
    @media screen and (max-width: ${lg}) {
        flex-direction: column;
        gap: 40px;
    }
`;

export const HideLg = styled.span`
    @media screen and (min-width: 1025px) {
        display: none;
    }
`;

export const HideXs = styled.span`
    @media screen and (max-width: ${lg}) {
        display: none;
    }
`;

export const Main = styled.span`
    @media screen and (min-width: 1025px) {
        width: 100%;
    }
`;

export const MenuItem = styled(ListItemButton)`
    display: flex;
    align-items: center;
`;

export const NavLink = styled(NavLinkComponent)`
    ${TextStyle({ fontSize: '15px', fontWeight: '500' })};
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
    text-transform: capitalize;
    fill: ${darkGray};
    min-height: 30px;
    box-sizing: border-box;
    cursor: pointer;

    &.active {
        fill: ${blue};
        color: ${blue};
        opacity: 1 !important;
    }
`;

export const NavLinkSpan = styled.div`
    display: flex;
`;

export const SbItem = styled.div`
    display: flex;
    align-items: center;
`;

export const SbItemContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 270px;
    width: 100%;
    height: 64px;
    padding: 0px 32px;
    gap: 10px;
    background: ${white};
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.03);
    border-radius: 4px;
    margin-bottom: 10px;
    color: ${darkBlack};
    height: 56px;
    width: 270px;
    &:active {
        background: ${white};
        color: ${purple};
    }
    @media screen and (max-width: 1024px) {
        min-width: 250px;
        max-width: 270px;
        justify-content: center;
        background: ${white};
        overflow: visible;
    }
    @media screen and (min-width: 1025px) {
        min-width: 305px;
    }
    @media screen and (max-width: ${lg}) {
        height: 64px;
    }
    @media screen and (min-width: 1025px) {
        min-width: 305px;
    }
`;

export const SideBar = styled.span`
    @media screen and (min-width: 1025px) {
        width: 270px;
    }
`;

export const Text = styled.p`
    ${TextStyle({ fontSize: '15px', fontWeight: '600' })};
    color: inherit;
`;

export const Title = styled.h4`
    margin-bottom: 16px;
`;

export const Value = styled.p`
    ${TextStyle({ fontSize: '15px', fontWeight: '400' })};
    margin-bottom: 18px;
`;
